module.exports = __webpack_public_path__ + "img/Butterfly_00079.35ac4cdb.png";